import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from './../../reducer';
import { isTicker } from '../../../../helpers/Common';
import IndexSumaryCommon from '../../../common/index-summary';
import { compose } from 'redux';
import { withComponentId } from './../../../../common/ComponentIdContext';

class IndexSumary extends React.Component {
  render() {
    const { indexSumary, data } = this.props;

    return (
      <IndexSumaryCommon
        isDerivatives={false}
        keyToCompare={'TradingDate'}
        data={data}
        isIndex={!isTicker(indexSumary)}
      />
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    indexSumary:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumary,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(IndexSumary);
